<template>
  <v-card outlined>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-subtitle class="pb-0">
      {{ subtitle }}
    </v-card-subtitle>
    <v-card-text class="pa-0 pb-1">
      <v-list two-line>
        <template v-for="(user, index) in shortData">
          <v-list-item
            :key="user.id"
            :to="`/photographer/${user.userName || user.userId}`"
            nuxt
          >
            <v-list-item-avatar>
              <v-img :src="user.avatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                <span class="font-weight-bold">
                  {{ user.fullName }}
                </span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <i class="fal fa-trophy"></i>
                {{ user.reputationPoint ? user.reputationPoint.toLocaleString() : 0 }} &#8226; {{ user.role }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-tooltip top>
                <template #activator="{ on }">
                  <v-chip
                    :color="$vuetify.theme.dark ? 'grey darken-3' : 'primary'"
                    small
                    v-on="on"
                  >
                    {{
                      user.totalNumberOfActions ||
                        user.totalNumberOfComments ||
                        user.numberOfPhotoPublished
                    }}
                  </v-chip>
                </template>
                <template v-if="user.totalNumberOfActions">
                  <span>
                    Total number of actions performed
                  </span>
                </template>
                <template v-if="user.totalNumberOfComments">
                  <span>
                    Total number of comments
                  </span>
                </template>
                <template v-if="user.numberOfPhotoPublished">
                  <span>
                    Total number of published photos
                  </span>
                </template>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
          <v-divider
            v-if="shortData.length > index + 1"
            :key="index"
            :inset="true"
          ></v-divider>
        </template>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-dialog v-model="viewMoreDialog" width="400">
        <template #activator="{ on }">
          <v-btn text small v-on="on" @click="trackGaEvent">
            View More
          </v-btn>
        </template>
        <v-card outlined>
          <v-card-title>
            {{ title }}
          </v-card-title>
          <v-card-subtitle class="pb-0">
            {{ subtitle }}
          </v-card-subtitle>
          <v-card-text class="pa-0 pb-1">
            <v-list two-line>
              <template v-for="(user, index) in data">
                <v-list-item
                  :key="user.id"
                  :to="`/photographer/${user.userName || user.userId}`"
                  nuxt
                >
                  <v-list-item-avatar>
                    <v-img :src="user.avatar"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span class="font-weight-bold">
                        {{ user.fullName }}
                      </span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      Rank {{ index + 1 }} &#8226;
                      <i class="fal fa-trophy"></i>
                      {{ user.reputationPoint ? user.reputationPoint.toLocaleString() : 0 }} &#8226; {{ user.role }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-tooltip top>
                      <template #activator="{ on }">
                        <v-chip
                          :color="
                            $vuetify.theme.dark ? 'grey darken-3' : 'primary'
                          "
                          small
                          v-on="on"
                        >
                          {{
                            user.totalNumberOfActions ||
                              user.totalNumberOfComments ||
                              user.numberOfPhotoPublished
                          }}
                        </v-chip>
                      </template>
                      <template v-if="user.totalNumberOfActions">
                        <span>
                          Total number of actions performed
                        </span>
                      </template>
                      <template v-if="user.totalNumberOfComments">
                        <span>
                          Total number of comments
                        </span>
                      </template>
                      <template v-if="user.numberOfPhotoPublished">
                        <span>
                          Total number of published photos
                        </span>
                      </template>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="data.length > index + 1"
                  :key="index"
                  :inset="true"
                ></v-divider>
              </template>
            </v-list>
            <div v-if="loading" class="pa-3 text-center">
              <v-icon class="fa-spin">
                fal fa-spinner
              </v-icon>
            </div>
          </v-card-text>
          <v-card-actions>
            <div v-intersect="onIntersect" />
            <v-spacer />
            <v-btn text small @click="viewMoreDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'LeaderboardUserCardList',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadMore: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      viewMoreDialog: false
    }
  },
  computed: {
    shortData() {
      return this.data.slice(0, 5)
    }
  },
  methods: {
    onIntersect(entries) {
      if (entries[0].intersectionRatio > 0 && !this.loading) {
        this.loadMore()
      }
    },
    trackGaEvent() {
      // this.$ga.event({
      //   eventCategory: 'tracking',
      //   eventAction: 'actions',
      //   eventLabel: 'leaderboard load more button',
      //   eventValue: true
      // })
    }
  }
}
</script>
